











































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { dictServe, doublePrevention } from '@/api/installServer';
import publicProp from '@/views/emergencyDrills/record/publicProp.vue';
import StatisticsPage from '@/views/emergencyDrills/record/statisticsPage.vue';

@Component({
  components: { PagingUnit, CollapseTransition, publicProp, StatisticsPage },
  mixins: [TableStripe],
})
export default class RiskControlList extends Vue {
  private searchForm: any = {
    way: '', // 演练方式
    search: '', // 模糊搜索
  };

  timers: any = []; // 查询时间
  wayList: any = []; // 应急队伍级别
  private tableLoading = false; // loading...
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  private formShow = true; // 是否显示搜索表单内容

  private pageIndex: any = 1;
  private rowProp: any = {};

  isShowForm() {
    this.formShow = !this.formShow;
  }

  // 点击按钮跳到相同的弹窗
  private jumpToPublicProp(type: any, data: any) {
    const passValue: any = {
      type: type,
      data: data,
    };
    if (type === 'delete') {
      this.$confirm('此操作将永久删除当前数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          doublePrevention.deleteEmergencyDrillRecord(data.id).then((res: any) => {
            if (res.code === '200') {
              this.$message.success('删除成功！');
              this.getTableData();
            } else {
              this.$message.warning('网络错误，请稍后再试！');
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    } else {
      this.pageIndex = 3;
      this.rowProp = passValue;
    }
  }

  private onSearch() {
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private onReset() {
    this.timers = [];
    this.searchForm = {
      way: '',
      search: '',
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getEmergencyDrillRecord({
        // ...this.queryDataForm,
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        way: this.searchForm.way ? this.searchForm.way : null,
        search: this.searchForm.search ? this.searchForm.search : null,
        drillTimeByStartDate: this.timers && this.timers.length ? this.timers[0] : null,
        drillTimeByEndDate: this.timers && this.timers.length ? this.timers[1] : null,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableLoading = false;
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.queryDataForm.pageSize = res.data.size;
        } else {
          this.$message.warning('获取数据失败！');
        }
      });
  }

  // 演练方式 的下拉
  getWayList() {
    dictServe.getDetailsMapByName('emergencyDrillWay').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.wayList = helpArr;
        console.log(this.wayList);
      } else {
        this.$message.warning('获取应急队伍类型下拉数据失败！');
      }
    });
  }

  created() {
    this.getTableData();
    this.getWayList();
  }

  jumpToStatistics() {
    this.pageIndex = 2;
  }
  closePage() {
    this.pageIndex = 1;
    this.getTableData();
  }
}
